import classNames from 'classnames';
import { forwardRef } from 'react';
const fieldBlockWidthLimitedCss = "fepmkw3";
const fieldBlockCss = "fna2arg";
export const FieldBlock = forwardRef((props, ref) => {
  const {
    widthLimited,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldBlockCss, {
    [fieldBlockWidthLimitedCss]: widthLimited
  }, props.className)} />;
});
const labelCss = "llj9f9f";
export const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");